"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (day) => Math.ceil(day / 7 + (day % 7 === 0 ? 0 : 1));
//# sourceMappingURL=calculateWeek.js.map